export default "__VITE_ASSET__x9IzUJ6pq32gOV4Wczuu7Q__"